import Display from '@/components/typography/Display';
import Button from '@/components/ui/Button';
import { useLanguage } from '@/contexts/LanguageContext';
import { useLocalizedPath } from '@/lib/locale';

export default function ChecklistCTA() {
  const { language } = useLanguage();
  const localizedPath = useLocalizedPath();
  const isGreek = language === 'el';

  return (
    <section className="my-12 pt-4 pb-4">
      <div className="relative overflow-hidden rounded-[32px] border border-white/15 bg-black/70 px-6 py-8 md:px-10 md:py-10 shadow-glass">
        <div className="pointer-events-none absolute -right-24 -top-32 h-72 w-72 rounded-full bg-brand-highlight/30 blur-3xl opacity-60" />
        <div className="pointer-events-none absolute -left-24 bottom-0 h-64 w-64 rounded-full bg-white/10 blur-3xl opacity-60" />
        <div className="pointer-events-none absolute inset-0 border border-white/5" aria-hidden="true" />

        <div className="relative flex flex-col gap-6">
          <div className="max-w-2xl">
            <p className="text-xs font-semibold uppercase tracking-[0.35em] text-brand-highlight/80 mb-3">
              {isGreek ? 'ΔΩΡΕΑΝ CHECKLIST' : 'FREE CHECKLIST'}
            </p>
            <Display
              variant="h2"
              as="h3"
              className="text-white text-2xl md:text-3xl font-semibold mb-3"
            >
              {isGreek ? 'Checklist Επαγγελματικής Ιστοσελίδας' : 'Professional Website Checklist'}
            </Display>
            <p className="text-white/70 text-base md:text-lg">
              {isGreek
                ? 'Έλεγξε σε 10 λεπτά αν η ιστοσελίδα σου χάνει πελάτες και πάρε καθαρή λίστα ενεργειών.'
                : 'Check in 10 minutes if your website is losing customers and get a clear action list.'}
            </p>
            <Button
              as="a"
              href={localizedPath('/checklist')}
              variant="primary"
              size="lg"
              className="mt-6 w-full justify-center tracking-[0.02em] !text-black hover:!text-brand-highlight sm:w-auto"
              trackCta={{
                text: isGreek ? 'Λάβε το δωρεάν checklist' : 'Get the free checklist',
                section: 'article_checklist_cta',
              }}
            >
              {isGreek ? 'Λάβε το δωρεάν checklist' : 'Get the free checklist'}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
